var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-query-helper"},_vm._l((_vm.screens),function(label,name){return _c('h1',{staticClass:"media-query-helper-heading",class:("media-query-helper-heading-" + name)},[_vm._v(" "+_vm._s(label)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }